import axios from "axios";
import { Localstorage } from "./Localstorage";
import { API_URL } from "@utils/constants";
import globalRouter from "../utils/globalRouter";

const jwtInterceptor = axios.create({});

const handleLogout = () => {
  Localstorage().clearAuth();
  if (globalRouter.navigate) {
    globalRouter.navigate("/login");
  } else {
    window.location.href = "/login";
  }
};

jwtInterceptor.interceptors.request.use((config) => {
  const auth = Localstorage().isAuth();
  if (auth) {
    const authObj = JSON.parse(auth);
    config.headers["x-access-token"] = authObj.token;
  }
  return config;
});

jwtInterceptor.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (error?.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        const auth = Localstorage().isAuth();
        const rememberMe = JSON.parse(localStorage.getItem('rememberMe') || "false");

        if (auth && rememberMe) {
          try {
            const authObj = JSON.parse(auth);

            const res = await axios.post(`${API_URL}/auth/refresh`, {
              refreshToken: authObj.refresh
            });

            if (!res.data.data.error) {
              const newToken = res.data.data.details.accessToken;

              Localstorage().setToken(newToken);

              originalRequest.headers["x-access-token"] = newToken;
              return jwtInterceptor(originalRequest);
            }
          } catch (refreshError) {
            handleLogout();
            return Promise.reject(refreshError);
          }
        }

        handleLogout();
      }

      return Promise.reject(error);
    }
);

export default jwtInterceptor;